import { ShieldCheckIcon as ShieldCheck } from "@phosphor-icons/react";

/**
 * Verified Seller Standards badge.
 *
 * Renders only when the seller has self-attested to the current
 * version of the platform's seller standards. The badge is purely
 * informational — it reflects the seller's self-attestation, not an
 * independent audit. Visible on listing cards, breeder cards, and
 * the escrow receipt PDF.
 */
export default function VerifiedStandardsBadge({ size = "sm", className = "" }) {
  const heights = {
    xs: "h-5 px-1.5 text-[9px]",
    sm: "h-6 px-2 text-[10px]",
    md: "h-7 px-2.5 text-[11px]",
    lg: "h-9 px-3 text-[12px]",
  };
  const cls = heights[size] || heights.sm;
  return (
    <span
      data-testid="verified-standards-badge"
      title="Seller has self-attested to all 15 items in Armstrong's seller standards. Click 'Seller standards' in the footer for the full list."
      className={`inline-flex items-center gap-1 rounded-full bg-[#0F8043]/10 text-[#0F8043] border border-[#0F8043]/30 font-bold uppercase tracking-[0.12em] ${cls} ${className}`}
    >
      <ShieldCheck size={size === "lg" ? 14 : 11} weight="fill" />
      <span>Verified standards</span>
    </span>
  );
}
